/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Notice_TraderInputs */

const en_seller_notice_trader = /** @type {(inputs: Seller_Notice_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The seller has told us it is a trader, so EU consumer rights apply.`)
};

const pl_seller_notice_trader = /** @type {(inputs: Seller_Notice_TraderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawca oświadczył nam, że jest przedsiębiorcą, więc obowiązują unijne prawa konsumenta.`)
};

/**
* | output |
* | --- |
* | "The seller has told us it is a trader, so EU consumer rights apply." |
*
* @param {Seller_Notice_TraderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seller_notice_trader = /** @type {((inputs?: Seller_Notice_TraderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Notice_TraderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seller_notice_trader(inputs)
	return en_seller_notice_trader(inputs)
});